export const __LOCAL__ = process.env.REACT_APP_LOCAL !== undefined;
export const __STAGING__ = process.env.REACT_APP_ENV !== "production";
